export default __webpack_public_path__ + "static/media/Profile_icon.0d8b18cd.svg";